import { jsx as _jsx } from "react/jsx-runtime";
import { Children, isValidElement } from 'react';
import styled, { css } from 'styled-components';
import { map } from '../breakpoint';
import { m, p } from '../spacing';
import { isList, isValidSpacing, getSpacingValue, mapColumnstoFlexBasis } from '../utils';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const TilesWrapper = styled(_ref => {
  let {
    as,
    space,
    columns,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    ...rest
  });
})`
  flex-wrap: wrap;

  /* If set to be a <ul> or <ol> we need to reset the default list styling */
  ${_ref2 => {
  let {
    as
  } = _ref2;
  return as && isList(as) && css`
      ${m(0)};
      ${p(0)};
      list-style-type: none;
    `;
}}

  > * {
    box-sizing: border-box;
    min-inline-size: 0;
    width: 100%;

    ${_ref3 => {
  let {
    columns
  } = _ref3;
  return map(columns, val => val && mapColumnstoFlexBasis(val));
}};
  }
  display: grid;

  ${_ref4 => {
  let {
    space
  } = _ref4;
  return map(space, val => isValidSpacing(val) && css`
          gap: ${getSpacingValue(val)};
        `);
}};

  ${_ref5 => {
  let {
    spaceVertical
  } = _ref5;
  return map(spaceVertical, val => isValidSpacing(val) && css`
          row-gap: ${getSpacingValue(val)};
        `);
}};

  ${_ref6 => {
  let {
    spaceHorizontal
  } = _ref6;
  return map(spaceHorizontal, val => isValidSpacing(val) && css`
          column-gap: ${getSpacingValue(val)};
        `);
}};

  ${_ref7 => {
  let {
    columns
  } = _ref7;
  return map(columns, val => val && css`
          grid-template-columns: repeat(${val}, minmax(0, 1fr));
        `);
}};
`;
const ChildWrapper = styled.div`
  ${_ref8 => {
  let {
    flex
  } = _ref8;
  return flex && `
    display: flex;
    width: 100%;
  `;
}};
`;
ChildWrapper.displayName = 'ChildWrapper';
export const Tiles = props => {
  const {
    children,
    space = 0,
    flex = false,
    ...otherProps
  } = props;
  const childComponent = isList(props.as) ? 'li' : 'div';
  return /*#__PURE__*/_jsx(TilesWrapper, {
    "data-mesh-component": "TILES",
    space: space,
    ...otherProps,
    children: Children.map(children, child => {
      if (/*#__PURE__*/isValidElement(child)) {
        return /*#__PURE__*/_jsx(ChildWrapper, {
          as: childComponent,
          flex: flex,
          children: child
        });
      }
      return null;
    })
  });
};
Tiles.displayName = 'Tiles';